import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconAdd = createIcon({
  displayName: 'IconAdd',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M11 3H13V11H21V13H13V21H11V13H3V11H11V3Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
